// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Wrap_wrap__bp1O2","top":"Wrap_top__Xkk_M","block":"Wrap_block__6P2F2","back":"Wrap_back__8iuEX","title":"Wrap_title__0WAOC","close":"Wrap_close__TxmSD"};